import { useState, useEffect, useContext } from "react";





const SmsBusTicket = () => {


    return (
        <>
            <div class="row">
                <div class="col-md-12">
                    <div class="form_row">
                        <label class="required">Mobile Number</label>
                        <input class="form-control" placeholder="Enter Mobile Number..." maxlength="10" type="text" value="" />
                    </div>
                </div>
                {/* <div class="col-md-12 mt-3">
                    <p>Select Desired Pricing Option (you can select only one option)</p>
                    <div class="d-flex"><div class="form-check m-3">
                        <input class="form-check-input" id="smsRadio1" type="radio" value="withPrice" name="smsPricing" />
                        <label class="form-check-label" for="smsRadio1">With Price</label>
                    </div>
                        <div class="form-check m-3">
                            <input class="form-check-input" id="smsRadio2" type="radio" value="withoutPrice" name="smsPricing" />
                            <label class="form-check-label" for="smsRadio2">Without Price</label>
                        </div>
                        <div class="form-check m-3">
                            <input class="form-check-input" id="smsRadio3" type="radio" value="hideMarkup" name="smsPricing" />
                            <label class="form-check-label" for="smsRadio3">Hide Markup</label>
                        </div>
                    </div>
                </div> */}
                <div class="col-md-12 text-end mt-3">
                    <button type="button" class="btn btn-primary btn-sm">Send SMS</button>
                </div>
            </div>

        </>
    );
};
export default SmsBusTicket;